// packages/chordpro/src/render-list.js
//
// Блоки документа → список к ОТРИСОВКЕ. Единственная работа: развернуть
// `{chorus}` из ссылки в полную копию припева.
//
// Почему разворот здесь, а не в parseChartDoc: разбор обязан оставаться
// честным к тексту. В документе стоит директива, а не второй экземпляр
// припева, и стирать этот факт нельзя — на нём стоит редактор.
//
// Почему вообще разворачиваем (это РАЗВОРОТ прежнего решения). Чип-ссылка
// читается лучше на бумаге, и так было сделано. Но при следовании за
// плейхедом подсветка на повторе уезжает НАЗАД, к первому припеву, и читатель
// теряет место — прототип это показал. Слова дешевле напечатать второй раз,
// чем заставлять глаз прыгать во время игры.
//
// Чего эта функция НЕ делает: не переставляет блоки в порядок аранжировки.
// Чарт, где припев написан один раз и ссылок нет вовсе (обычный результат
// вставки из holychords), так и останется с одним припевом — это свойство
// документа, а не отрисовки, и выдумывать за автора мы не будем.

import { normalizeSectionName } from './section-name.js';

/**
 * @param {Array} blocks выход parseChartDoc().blocks
 * @returns {Array} тот же массив, если ссылок нет; иначе новый со вставленными копиями
 */
export function renderList(blocks) {
  const src = Array.isArray(blocks) ? blocks : [];
  if (!src.some((b) => b && b.ref)) return src;

  const bodies = src.filter((b) => b && !b.ref && b.name && b.lines && b.lines.length);

  const find = (wanted) => {
    const w = normalizeSectionName(wanted);
    if (w.key) {
      const exact = bodies.find((b) => normalizeSectionName(b.name).key === w.key);
      if (exact) return exact;
      if (w.family) {
        const fam = bodies.find((b) => normalizeSectionName(b.name).family === w.family);
        if (fam) return fam;
      }
    }
    return bodies.find((b) => b.kind === 'chorus') || null;
  };

  return src.map((b) => {
    if (!b || !b.ref) return b;
    const target = find(b.name);
    // Припева нет — ссылку оставляем ссылкой. Пустой блок «Chorus» без слов
    // хуже честного «см. припев»: он выглядит как потерянный текст.
    if (!target) return b;
    return {
      ...b,
      ref: false,
      repeat: true,
      kind: target.kind,
      name: target.name,
      // Копия, а не та же ссылка на массив: отрисовка вправе дописывать в
      // строки свои поля, и подмена в копии не должна менять оригинал.
      lines: target.lines.map((l) => ({ ...l })),
    };
  });
}
